module.exports = __webpack_public_path__ + "img/41.17152a55.svg";